import React, {ReactElement, useEffect, useRef, useState} from "react";
import styles from "./LeftMenuContentElement.module.scss";
import {
    FlyerPageSpotDto,
    ItemsListMenuDto,
    PromoDto,
    PromoItemsDto,
    SaleTypeDto,
    SelectPageForTabsDto, SellingUnitDto,
    UserDto,
} from "../../../../../../dtos";
// import {
//     ReactComponent as LinkedPromoToFrame
// } from "../../../../../../assets/promos&items/unlink_promo_from_frame_icon.svg";
import {ReactComponent as PromotionIcon} from "../../../../../../assets/promos&items/promotion_icon.svg";
import {
    ReactComponent as ToggleCollapseItemsInPromotion
} from "../../../../../../assets/promos&items/toggle_collapse_items_in_promotion_icon.svg";
import {ReactComponent as DragIcon} from "../../../../../../assets/promos&items/drag_icon.svg";
import {ReactComponent as MenuOnHover} from "../../../../../../assets/promos&items/menu_on_hover.svg";
import {hideMenu} from "react-contextmenu/modules/actions";
import {
    Draggable,
    DraggableStateSnapshot,
    DraggingStyle,
    Droppable,
    NotDraggingStyle,
} from "react-beautiful-dnd";
import {PromotionItem} from "./LeftMenuPromotionItem/LeftMenuPromotionItem";
import {useTypedSelector} from "../../../../../../hooks/useTypeSelector";
import {
    attachItemsToFlyer,
    attachPromoToFlyer,
    // changeQualificationStatusForItems,
    changeQualificationStatusForPromos,
} from "../../../../../../store/actionCreators/promotionsItemsCreators";
import {useDispatch} from "react-redux";
// import Tooltip from '@material-ui/core/Tooltip';
import {MenuForPromotion} from "./MenuForPromotions/menuForPromotions";
// import Button from "@material-ui/core/Button";
import {PromotionDetailsModalPopup} from "./PromotionDetailsModalPopup/PromotionDetailsModalPopup";
import {getPromoSaleTypeCaptions} from "../../../../../../globals/PromoSaleTypeCaptionGenerator";
import {CreateEditItemModal} from "./LeftMenuPromotionItem/CreateEditItemModal/CreateEditItemModal";
// import Button from '@mui/material/Button';
import {
    QualificationForPromoComponent
} from "../../../../../com/QualificationForPromoComponent/QualificationForPromoComponent";
import {Box, Button, Typography} from "@mui/material";
import {ReactComponent as NotApproveFrame} from "../../../../../../assets/promos&items/not_approved_promo.svg";
import {ReactComponent as ApproveFrame} from "../../../../../../assets/promos&items/approved_promo.svg";
import {ReactComponent as ApproveFrameForSystem} from "../../../../../../assets/promos&items/approved_promo_system.svg";
import {changeQualificationStatusForFrame} from "../../../../../../store/actionCreators/spotsActionCreators";
// import {ReactComponent as JumpToPageIcon} from "../../../../../../assets/jump_to_page_flyer_icon.svg";
// import {ReactComponent as JumpToURLIcon} from "../../../../../../assets/jump_to_URL_icon.svg";
// import {ReactComponent as PlayVideoIcon} from "../../../../../../assets/play_video_icon.svg";
// import {ReactComponent as Play360VideoIcon} from "../../../../../../assets/play_360_video_icon.svg";
// import {ReactComponent as ImageIcon} from "../../../../../../assets/open_image_url_icon.svg";
// import StatusPopup, {StatusPopupType} from "../../../../../../com/statusPopup/StatusPopup";
import {getIconStyle} from "../../../../../../globals/globFunctions";


interface Props {
    frame: FlyerPageSpotDto;
    promo: PromoDto;
    index: number;
    isHebrew: boolean;
    currencySymbol: string;
    frames: FlyerPageSpotDto[];
    setFrames: (e: FlyerPageSpotDto[]) => void;
    setTargetPromos: (e: any) => void;
    onSelectFrame: (event: React.MouseEvent<HTMLElement>, promo: PromoDto, index: number, frame: FlyerPageSpotDto) => void;
    isSelect: boolean;
    onChangeExpandedPromosData: (isAddPromo: boolean, targetPromo: PromoDto) => void;
    expandedPromos: PromoDto[];
}

export const LeftMenuContentElement = React.memo(
    (props: Props) => {
        const saleTypes = useTypedSelector(
            (state) => state.saleTypes.saleTypesForSpecificFlyer
        );

        let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
        const sellingUnitsForFlyer = useTypedSelector((state) => state.sellingUnits.sellingUnitsForFlyer);
        const dispatch = useDispatch();
        const flyerIconStyleType = flyerDetailsState.flyGusRec?.gusIconContrast || 1;
        const mainGuiColorForFlyer = flyerDetailsState.flyGusRec?.gusPrimaryColorRgb || "#ffffff";
        const iconStyleData = getIconStyle(flyerIconStyleType);
        // const IconPromoComp = iconStyleData.iconStyleData.promoCompIcon;
        const IconPageComp = iconStyleData.iconStyleData.pageCompIcon;
        const IconLinkComp = iconStyleData.iconStyleData.linkCompIcon;
        const IconVideoComp = iconStyleData.iconStyleData.videoCompIcon;
        const IconImageComp = iconStyleData.iconStyleData.imgCompIcon;
        const Icon360Comp = iconStyleData.iconStyleData.img360CompIcon;

        const promotionsItemsState = useTypedSelector(
            (state) => state.promotionsAndItems
        );
        let selectedPageState = useTypedSelector<SelectPageForTabsDto>(
            (state) => state.selectPageForTabs
        );
        const [caption, setCaption] = useState<string>("");
        const [isShowItems, setStatusForShowItem] = useState<boolean>(false);
        // const [isShowItems, setStatusForShowItem] = useState<boolean>(
        //     promotionsItemsState.isShowsAllItemsOfPromotions
        // );
        const [promoQualification, setPromoQualificationStatus] = useState<number | undefined>(props.promo?.qualificationLevel);
        const [userName, setUserName] = useState<string>("");

        //frame menu
        const [isHover, changeHoverStatus] = useState<boolean>(false);
        const [isOpenedFrameMenu, setOpenFrameMenu] = useState(false);
        const prevOpenFrameMenu = useRef(isOpenedFrameMenu);

        //promo menu
        const [isHoverOnPromotion, changeHoverOnPromotionStatus] =
            useState<boolean>(false);
        const [openPromotionMenu, setOpenPromotionMenu] = useState(false);
        const prevOpenPromotionMenu = useRef(openPromotionMenu);

        //popup promo
        const [isOpenPromotionModalPopup, openPromotionModalPopup] =
            useState<boolean>(false);
        const [isNewPromotion, setStatusForNewOrNotForPromotion] =
            useState<boolean>(false);

        //popup item
        let [isOpenItemModal, setOpenItemModal] = useState<boolean>(false);
        const [imageSrc, setImageSrc] = useState<string>('');
        const [isNewItem, setStatusForNewOrNotForItem] = useState<boolean>(false);
        const [selectedItem, setSelectedItem] = useState<PromoItemsDto>({});

        const [isShowCaptionForPromotion, toggleShowCaptionForPromotion] = useState<boolean>(false);

        let userDtoStr = localStorage.getItem('userDto');
        let isUserViewer = true;
        let isUserEditor = false;
        if(userDtoStr){
            let userDto: UserDto = JSON.parse(userDtoStr);
            isUserViewer = userDto.role !== 2 && userDto.role !== 3;
            isUserEditor = userDto.role === 2;
        }

        useEffect(() => {
            if (props.promo) {
                const isShowItemsInPromo: boolean = [...props.expandedPromos].some((expandedPromo: PromoDto) => expandedPromo.flrRecId === props.promo.flrRecId);
                setStatusForShowItem(isShowItemsInPromo);
            }
        }, [props.expandedPromos])

        useEffect(() => {
            if (
                promotionsItemsState.pages[
                    selectedPageState.pageNo !== 0
                        ? selectedPageState.pageNo - 1
                        : selectedPageState.pageNo
                    ]
            ) {
                const currentPromo = promotionsItemsState.pages[
                    selectedPageState.pageNo !== 0
                        ? selectedPageState.pageNo - 1
                        : selectedPageState.pageNo
                    ].promos.filter((promo: PromoDto) => {
                    if (props.promo) {
                        return promo.flrRecId === props.promo.flrRecId;
                    }
                });
                if (currentPromo.length) {
                    setPromoQualificationStatus(
                        currentPromo[0]
                            ? currentPromo[0].qualificationLevel
                            : props.promo?.qualificationLevel
                    );
                }
            }
        }, [promotionsItemsState.pages]);

        useEffect(() => {
            let userDtoStr = localStorage.getItem("userDto");

            if (userDtoStr) {
                let userDto: UserDto = JSON.parse(userDtoStr);

                if (userDto.firstName && userDto.lastName) {
                    setUserName(`${userDto.firstName} ${userDto.lastName}`);
                } else {
                    setUserName("you");
                }
            }
        }, []);

        useEffect(() => {
            //flyer type
            const isFlyerWithPrices = flyerDetailsState.flyFltRec.fltCode !== 3;
            if (
                isFlyerWithPrices
                || (
                    !isFlyerWithPrices
                    && (
                        props.promo?.flrSatCode === 20
                        || props.promo?.flrSatCode === 21
                        || props.promo?.flrSatCode === 50
                        || props.promo?.flrSatCode === 51
                        || props.promo?.flrSatCode === 1
                        || props.promo?.flrSatCode === 30
                        || props.promo?.flrSatCode === 41
                        || props.promo?.flrSatCode === 50
                        || props.promo?.flrSatCode === 80
                    )
                )
            ) {
                toggleShowCaptionForPromotion(true);
            } else {
                toggleShowCaptionForPromotion(false);
            }
        }, [flyerDetailsState, props.promo])

        useEffect(() => {
            setPromoQualificationStatus(props.promo?.qualificationLevel);
        }, [props.promo?.qualificationLevel]);

        const handleToggle = () => {
            setOpenPromotionMenu((prevOpen) => !prevOpen);
        };

        const handleToggleForFrame = () => {
            setOpenFrameMenu((prevOpen) => !prevOpen);
        };

        const anchorRef = useRef(null);
        const anchorRefForFrameMenu = useRef(null);

        // useEffect(() => {
        //     setStatusForShowItem(promotionsItemsState.isShowsAllItemsOfPromotions);
        // }, [promotionsItemsState.isShowsAllItemsOfPromotions]);

        useEffect(() => {
            const selectedSaleType = saleTypes.find(
                (saleType: SaleTypeDto) => saleType.satCode === props.promo?.flrSatCode
            );
            const selectedSellingUnit = sellingUnitsForFlyer?.find((sellingUnit: SellingUnitDto) => {
                if (sellingUnit.id === props.promo?.flrSeuRecId) {
                    return sellingUnit;
                }
            })

            if (selectedSaleType) {
                setCaption(
                    getPromoSaleTypeCaptions(
                        selectedSaleType,
                        props.currencySymbol,
                        selectedSellingUnit,
                        props.promo
                    )
                );
            }
        }, [props.promo]);

        const onClickFrame = (e: React.MouseEvent<HTMLElement>) => {
            // e.preventDefault();
            // e.stopPropagation();
            document?.getSelection()!.removeAllRanges();
            hideMenu();
            // if(!props.isSelect){
            // if (props.promo) {
            props.onSelectFrame(e, props.promo, props.index, props.frame);
            // }
            // }
        };
        //prevent transition for draggable elem

        const getStyle = (
            style: DraggingStyle | NotDraggingStyle | undefined,
            snapshot: DraggableStateSnapshot
        ) => {
            if (!snapshot.isDragging) return {};
            if (!snapshot.isDropAnimating) {
                return style;
            }

            return {
                ...style,
                // cannot be 0, but make it super tiny
                transitionDuration: `0.001s`,
            };
        };

        const onMouseEnter = () => {
            changeHoverStatus(true);
        };
        const onMouseLeave = () => {
            changeHoverStatus(false);
            setOpenFrameMenu(false);
        };

        const onMouseEnterPromo = () => {
            changeHoverOnPromotionStatus(true);
        };

        const onMouseLeavePromo = () => {
            changeHoverOnPromotionStatus(false);
            setOpenPromotionMenu(false);
        };

        const makeUnlinkTargetPromo = () => {
            let targetPromo: PromoDto[] = [...props.frame.flyerPromos!];
            props.setTargetPromos(targetPromo);
            dispatch(
                attachPromoToFlyer(
                    flyerDetailsState.flyRecId,
                    [targetPromo[0].flrRecId!],
                    false,
                    flyerDetailsState.flyLacRec.lacCode
                )
            );
        };

        const createNewPromotion = () => {
            setStatusForNewOrNotForPromotion(true);
            openPromotionModalPopup(true);
        };

        const editFrame = () => {

        };

        const editPromotion = (e: React.MouseEvent<HTMLElement>) => {
            e.preventDefault();
            e.stopPropagation();
            setStatusForNewOrNotForPromotion(false);
            openPromotionModalPopup(true);
        };

        const isDisableDraggable = props.frame.flyerPromos?.length === 0 || flyerDetailsState.flyFstRec.fstCaption === "Published";

        const showHideItems = () => {
            props.onChangeExpandedPromosData(!isShowItems, props.promo);
            // setStatusForShowItem(!isShowItems);
        };

        const changeQualificationForPromo = () => {
            if (promoQualification !== 0) {
                dispatch(
                    changeQualificationStatusForPromos(
                        [props.promo.flrRecId!],
                        flyerDetailsState?.flyLacRec?.lacCode!,
                        promoQualification === 1 ? 2 : 1,
                        flyerDetailsState,
                        false,
                        selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo
                    )
                );
                // let itemsQualification: number[] = [];
                //
                // props.promo.flyerPromoItems?.forEach((item: PromoItemsDto) => {
                //     itemsQualification.push(item.fpiRecId!);
                // });
                // if(itemsQualification && itemsQualification.length){
                //     dispatch(
                //         changeQualificationStatusForItems(
                //             itemsQualification,
                //             flyerDetailsState?.flyLacRec?.lacCode!,
                //             promoQualification === 1 ? 2 : 1,
                //             false,
                //             flyerDetailsState,
                //             selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo
                //         )
                //     );
                // }
                // setPromoQualificationStatus(promoQualification === 1 ? 2 : 1);
            }
        };

        const createNewItem = (e: React.MouseEvent<HTMLElement>) => {
            e.preventDefault();
            e.stopPropagation();
            setOpenItemModal(true);
            setStatusForNewOrNotForItem(true);
            setSelectedItem({});
        };

        const onEditItem = (promoItem: PromoItemsDto) => {
            setStatusForNewOrNotForItem(false);
            setImageSrc(promoItem.fpiImage ? promoItem.fpiImage : '');
            setOpenItemModal(true);
            setSelectedItem(promoItem);
        }

        const unlinkAllItemFromPromoSelectedPromo = () => {
            console.log(props.promo);
            if (props.promo?.flyerPromoItems) {
                const promoItemsIds: number[] = props.promo?.flyerPromoItems?.map((item: PromoItemsDto) => item.fpiRecId!);
                dispatch(attachItemsToFlyer(flyerDetailsState.flyRecId, promoItemsIds, false, props.promo, props.frame?.fpsRecId!))
            }
        }

        const setQualificationForFrame = () => {
            if (promoQualification !== 0) {
                dispatch(changeQualificationStatusForFrame(
                    [props.frame.fpsRecId!],
                    flyerDetailsState?.flyLacRec?.lacCode!,
                    props.frame && props.frame.qualificationLevel === 1 ? 2 : 1,
                    flyerDetailsState,
                    selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo,
                    []
                ));
            }
        }

        const clickMenuDataForPromotion: ItemsListMenuDto = {
            setOpen: setOpenPromotionMenu,
            prevOpen: prevOpenPromotionMenu,
            open: openPromotionMenu,
            anchorRef: anchorRef,
        };

        const clickMenuDataForFrame: ItemsListMenuDto = {
            setOpen: setOpenFrameMenu,
            prevOpen: prevOpenFrameMenu,
            open: isOpenedFrameMenu,
            anchorRef: anchorRefForFrameMenu,
        };
        //Department for frame/promo using first item
        let department: string;
        if (
            props.frame.flyerPromos?.length &&
            props.frame.flyerPromos[0]?.flyerPromoItems &&
            props.frame.flyerPromos[0]?.flyerPromoItems.length &&
            props.frame.flyerPromos[0]?.flyerPromoItems[0] !== null && props.frame.flyerPromos[0]?.flyerPromoItems[0].fpiDeptName
        ) {
            department = props.frame.flyerPromos[0]?.flyerPromoItems[0].fpiDeptName;
        } else {
            department = "";
        }

        let frameTypeTitle: string;
        let frameIcon: ReactElement;
        switch (props.frame.fpsFrameType) {
            case 2:
                frameTypeTitle = props.frame.fpsTooltip ? props.frame.fpsTooltip : `Frame Type - Jump to Flyer Page`;
                frameIcon = <IconPageComp style={{width: `100%`, height: `100%`}}/>;
                break;
            case 3:
                frameTypeTitle = props.frame.fpsTooltip ? props.frame.fpsTooltip : `Frame Type - Open Url`;
                frameIcon = <IconLinkComp style={{width: `100%`, height: `100%`}}/>;
                break;
            case 4:
                frameTypeTitle = props.frame.fpsTooltip ? props.frame.fpsTooltip : `Frame Type - Open Video`;
                frameIcon = <IconVideoComp style={{width: `100%`, height: `100%`}}/>;
                break;
            case 5:
                frameTypeTitle = props.frame.fpsTooltip ? props.frame.fpsTooltip : `Frame Type - Open Image`;
                frameIcon = <IconImageComp style={{width: `100%`, height: `100%`}}/>;
                break;
            case 6:
                frameTypeTitle = props.frame.fpsTooltip ? props.frame.fpsTooltip : `Frame Type - Open 360 Image`;
                frameIcon = <Icon360Comp style={{width: `100%`, height: `100%`}}/>;
                break;
            default:
                frameTypeTitle = props.frame.fpsTooltip ? props.frame.fpsTooltip : `Uncovered Frame Type`;
                frameIcon = <></>
                break;
        }

        const isNotPromoFrameType = props.frame.fpsFrameType !== 1;

        return (
            <>
                <div
                    className={`
                    ${styles.frame_wrap} 
                    ${props.isHebrew ? styles.is_hebrew : ""}
                    `}
                    onClick={onClickFrame}
                >
                    <div
                        className={`
                        ${styles.frame_promo_wrap} 
                        ${!props.isSelect && isHover ? styles.hover_frame : ""}
                        ${props.isSelect ? styles.isSelectPromo : ""}
                        `}
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}

                    >
                        {props.frame.flyerPromos && props.frame.flyerPromos.length > 0 && !isNotPromoFrameType ? (
                            <Droppable droppableId={`${props.frame.fpsRecId?.toString()}`}>
                                {({innerRef, placeholder, droppableProps}) => (
                                    <div
                                        ref={innerRef}
                                        {...droppableProps}
                                        className={`${styles.frame_promo_container} ${styles.frame_promo_container_without_placeholder}`}
                                    >
                                        <Draggable
                                            disableInteractiveElementBlocking={true}
                                            draggableId={`${props.frame.fpsRecId?.toString()}`}
                                            isDragDisabled={isDisableDraggable}
                                            index={props.index}
                                        >
                                            {(
                                                {innerRef, draggableProps, dragHandleProps},
                                                snapshot
                                            ) => (
                                                <div
                                                    className={`${styles.frame_promo}`}
                                                    ref={innerRef}
                                                    {...draggableProps}
                                                    style={getStyle(draggableProps.style, snapshot)}
                                                >
                                                    <div
                                                        className={`${styles.promo_wrapper} ${
                                                            !props.promo.flyerPromoItems?.length
                                                                ? styles.align_center
                                                                : ""
                                                        }`}
                                                    >
                                                        <div className={styles.promo_info_wrapper}>
                                                            <div className={styles.frame_info_wrapper}>
                                                                <div className={styles.frame_info}>
                                                                    <div className={styles.frame_number}>
                                                                        Frame {props.frame.fpsCode}
                                                                    </div>
                                                                    {department !== "" && (
                                                                        <div className={styles.promos_category}>
                                                                            {department}
                                                                            {/*{props.frame.fpsCaption ? props.frame.fpsCaption : 'Department'}*/}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                {
                                                                    promotionsItemsState.isQualified &&
                                                                    <Button
                                                                        sx={{
                                                                            display: `flex`,
                                                                            cursor: `${props.frame.qualificationLevel !== 0 ? `pointer` : `initial`}`,
                                                                            "&:disabled": {
                                                                                opacity: "0.5"
                                                                            }
                                                                        }}
                                                                        onClick={setQualificationForFrame}
                                                                        disabled={props.frame.qualificationLevel === 0 || isUserViewer || isUserEditor}
                                                                    >
                                                                        {
                                                                            props.frame.qualificationLevel === 0 &&
                                                                            <NotApproveFrame
                                                                                title={`Frame Unqualified/Empty.`}/>
                                                                        }
                                                                        {
                                                                            props.frame.qualificationLevel === 1 &&
                                                                            <ApproveFrameForSystem
                                                                                title={`Frame Qualified by System.`}/>
                                                                        }
                                                                        {
                                                                            props.frame.qualificationLevel === 2 &&
                                                                            <ApproveFrame title={`Frame Qualified.`}/>
                                                                        }
                                                                    </Button>
                                                                }
                                                                {isHover &&
                                                                    props.frame.flyerPromos?.length! > 0 && (
                                                                        <div
                                                                            className={
                                                                                styles.right_corner_menu_for_target
                                                                            }
                                                                        >
                                                                            <Button
                                                                                disableRipple={true}
                                                                                ref={anchorRefForFrameMenu}
                                                                                aria-controls={
                                                                                    isOpenedFrameMenu
                                                                                        ? "menu-list-grow"
                                                                                        : undefined
                                                                                }
                                                                                aria-haspopup="true"
                                                                                onClick={handleToggleForFrame}
                                                                                disabled={isUserViewer}
                                                                                sx={{
                                                                                    "&:disabled": {
                                                                                        opacity: "0.5"
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <MenuOnHover/>
                                                                            </Button>
                                                                            <MenuForPromotion
                                                                                list={clickMenuDataForFrame}
                                                                                makeUnlinkTargetPromo={
                                                                                    makeUnlinkTargetPromo
                                                                                }
                                                                                editPromotion={editPromotion}
                                                                                createNewPromotion={
                                                                                    createNewPromotion
                                                                                }
                                                                                infoForMenu={`menuForFrameWithPromo`}
                                                                            />
                                                                        </div>
                                                                    )}
                                                            </div>
                                                            <div
                                                                className={`${
                                                                    styles.promotion_info_container
                                                                } ${isHoverOnPromotion ? styles.hover : ""}`}
                                                                onMouseEnter={onMouseEnterPromo}
                                                                onMouseLeave={onMouseLeavePromo}
                                                            >
                                                                <div className={styles.promotion_content}>
                                                                    <div className={styles.promotion_info}>
                                                                        <div className={styles.promotion_icon}>
                                                                            <PromotionIcon/>
                                                                        </div>
                                                                        <div className={styles.promotion_details}>
                                                                            {
                                                                                isShowCaptionForPromotion &&
                                                                                <div
                                                                                    className={
                                                                                        styles.promotion_caption_name
                                                                                    }
                                                                                    title={caption}
                                                                                >
                                                                                    <span>{caption}</span>
                                                                                </div>
                                                                            }
                                                                            <div
                                                                                className={`${
                                                                                    styles.promotion_items_wrapper
                                                                                } ${
                                                                                    promotionsItemsState.isQualified
                                                                                        ? styles.with_quality
                                                                                        : ""
                                                                                }`}
                                                                            >
                                                                                <div
                                                                                    className={`${styles.promotion_items_caption}`}
                                                                                    title={props.promo.flrCaption}
                                                                                >
                                                                                    <span>{props.promo.flrCaption}</span>
                                                                                </div>
                                                                                {/*<div*/}
                                                                                {/*    className={`${styles.toggle_collapse_icon_wrapper} ${isShowItems ? styles.is_open : ''}`}*/}
                                                                                {/*    onClick={showHideItems}>*/}
                                                                                {/*    <ToggleCollapseItemsInPromotion/>*/}
                                                                                {/*</div>*/}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        className={
                                                                            styles.promotion_right_part_wrapper
                                                                        }
                                                                    >
                                                                        <div
                                                                            className={styles.promotion_code_group}
                                                                        >
                                                                            <div
                                                                                title={props.promo.flrCode?.toString()}
                                                                                className={`${styles.promotion_code} ${
                                                                                    promotionsItemsState.isQualified
                                                                                        ? styles.is_qualification_mode
                                                                                        : ""
                                                                                }`}
                                                                            >
                                                                                Code: {props.promo.flrCode}
                                                                            </div>
                                                                            {promotionsItemsState.isQualified && (
                                                                                <Button
                                                                                    className={
                                                                                        styles.promo_qualification_icon
                                                                                    }
                                                                                    disabled={isUserViewer || isUserEditor}
                                                                                    sx={{
                                                                                        "&:disabled": {
                                                                                            opacity: "0.5"
                                                                                        }
                                                                                    }}
                                                                                    onClick={changeQualificationForPromo}
                                                                                >
                                                                                    <QualificationForPromoComponent
                                                                                        promo={props.promo}
                                                                                        caption={caption}
                                                                                        editPromotion={editPromotion}
                                                                                        promoQualification={
                                                                                            promoQualification
                                                                                        }
                                                                                        isShowPromoCaption={isShowCaptionForPromotion}
                                                                                        frame={props.frame}
                                                                                    />
                                                                                </Button>
                                                                            )}
                                                                        </div>
                                                                        {props.promo.flyerPromoItems?.length! >
                                                                            0 && (
                                                                                <div
                                                                                    className={`${styles.arrow_wrapper}`}
                                                                                >
                                                                                    <div
                                                                                        className={`${
                                                                                            styles.toggle_collapse_icon_wrapper
                                                                                        } ${
                                                                                            isShowItems ? styles.is_open : ""
                                                                                        } ${
                                                                                            promotionsItemsState.isQualified
                                                                                                ? styles.arrow_with_margin
                                                                                                : ""
                                                                                        }`}
                                                                                        onClick={showHideItems}
                                                                                    >
                                                                                        <ToggleCollapseItemsInPromotion/>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                </div>

                                                                {isHoverOnPromotion && (
                                                                    <>
                                                                        <div
                                                                            className={
                                                                                styles.right_corner_menu_for_target
                                                                            }
                                                                        >
                                                                            <Button
                                                                                disableRipple={true}
                                                                                ref={anchorRef}
                                                                                aria-controls={
                                                                                    openPromotionMenu
                                                                                        ? "menu-list-grow"
                                                                                        : undefined
                                                                                }
                                                                                aria-haspopup="true"
                                                                                onClick={handleToggle}
                                                                                disabled={isUserViewer}
                                                                                sx={{
                                                                                    "&:disabled": {
                                                                                        opacity: "0.5"
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <MenuOnHover/>
                                                                            </Button>
                                                                            <MenuForPromotion
                                                                                isPromotionIncludeItems={props.promo.flyerPromoItems && props.promo.flyerPromoItems?.length > 0}
                                                                                list={clickMenuDataForPromotion}
                                                                                makeUnlinkTargetPromo={
                                                                                    makeUnlinkTargetPromo
                                                                                }
                                                                                editPromotion={editPromotion}
                                                                                infoForMenu={`menuForPromo`}
                                                                                createNewItem={createNewItem}
                                                                                unlinkAllItemFromPromoSelectedPromo={unlinkAllItemFromPromoSelectedPromo}

                                                                                // createNewPromotion={createNewPromotion}
                                                                            />
                                                                        </div>
                                                                        {
                                                                            !isDisableDraggable &&
                                                                            <div
                                                                                className={styles.draggable_area}
                                                                                {...dragHandleProps}
                                                                                {...draggableProps}
                                                                            >
                                                                                <DragIcon/>
                                                                            </div>

                                                                        }
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {props.promo.flyerPromoItems?.length! > 0 &&
                                                        isShowItems && (
                                                            <div className={styles.list_of_items}>
                                                                <ul>
                                                                    {props.promo.flyerPromoItems?.map(
                                                                        (item: PromoItemsDto) => {
                                                                            return (
                                                                                <PromotionItem
                                                                                    key={item.fpiRecId}
                                                                                    item={item}
                                                                                    isQualification={
                                                                                        promotionsItemsState.isQualified
                                                                                    }
                                                                                    isUnlinkPromo={false}
                                                                                    frames={props.frames}
                                                                                    frame={props.frame}
                                                                                    setFrames={props.setFrames}
                                                                                    userName={userName}
                                                                                    promo={props.promo}
                                                                                    unlinkAllItemFromPromoSelectedPromo={unlinkAllItemFromPromoSelectedPromo}
                                                                                    onEditItem={onEditItem}
                                                                                    // statusForApproveAll={props.statusForApproveAll}
                                                                                />
                                                                            );
                                                                            /*
                                                                                                                                                        if (promotionsItemsState.pages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo]) {
                                                                                                                                                            const currentItem = promotionsItemsState.pages[
                                                                                                                                                                selectedPageState.pageNo !== 0
                                                                                                                                                                    ? selectedPageState.pageNo - 1
                                                                                                                                                                    : selectedPageState.pageNo
                                                                                                                                                                ].items.filter(
                                                                                                                                                                (promoItem: PromoItemsDto) => {
                                                                                                                                                                    return (
                                                                                                                                                                        promoItem.fpiRecId ===
                                                                                                                                                                        item.fpiRecId
                                                                                                                                                                    );
                                                                                                                                                                }
                                                                                                                                                            );
                                                                                                                                                            if (currentItem && currentItem.length) {
                                                                                                                                                                return (
                                                                                                                                                                    <PromotionItem
                                                                                                                                                                        key={
                                                                                                                                                                            currentItem[0]
                                                                                                                                                                                ? currentItem[0].fpiRecId
                                                                                                                                                                                : item.fpiRecId
                                                                                                                                                                        }
                                                                                                                                                                        item={
                                                                                                                                                                            currentItem[0]
                                                                                                                                                                                ? currentItem[0]
                                                                                                                                                                                : item.fpiRecId
                                                                                                                                                                        }
                                                                                                                                                                        isQualification={
                                                                                                                                                                            promotionsItemsState.isQualified
                                                                                                                                                                        }
                                                                                                                                                                        isUnlinkPromo={false}
                                                                                                                                                                        frames={props.frames}
                                                                                                                                                                        frame={props.frame}
                                                                                                                                                                        setFrames={props.setFrames}
                                                                                                                                                                        userName={userName}
                                                                                                                                                                        promo={props.promo}
                                                                                                                                                                        unlinkAllItemFromPromoSelectedPromo={unlinkAllItemFromPromoSelectedPromo}
                                                                                                                                                                        onEditItem={onEditItem}
                                                                                                                                                                        // statusForApproveAll={props.statusForApproveAll}
                                                                                                                                                                    />
                                                                                                                                                                );
                                                                                                                                                            } else {
                                                                                                                                                                return (
                                                                                                                                                                    <PromotionItem
                                                                                                                                                                        key={item.fpiRecId}
                                                                                                                                                                        item={item}
                                                                                                                                                                        isQualification={
                                                                                                                                                                            promotionsItemsState.isQualified
                                                                                                                                                                        }
                                                                                                                                                                        isUnlinkPromo={false}
                                                                                                                                                                        frames={props.frames}
                                                                                                                                                                        frame={props.frame}
                                                                                                                                                                        setFrames={props.setFrames}
                                                                                                                                                                        userName={userName}
                                                                                                                                                                        promo={props.promo}
                                                                                                                                                                        unlinkAllItemFromPromoSelectedPromo={unlinkAllItemFromPromoSelectedPromo}
                                                                                                                                                                        onEditItem={onEditItem}
                                                                                                                                                                        // statusForApproveAll={props.statusForApproveAll}
                                                                                                                                                                    />
                                                                                                                                                                );
                                                                                                                                                            }
                                                                                                                                                        }
                                                                            */
                                                                        }
                                                                    )}
                                                                </ul>
                                                            </div>
                                                        )}
                                                </div>
                                            )}
                                        </Draggable>
                                        {placeholder}
                                    </div>
                                )}
                            </Droppable>
                        ) : (
                            <Droppable droppableId={`${props.frame.fpsRecId?.toString()}`}
                                       isDropDisabled={isNotPromoFrameType}>
                                {({innerRef, placeholder, droppableProps}) => (
                                    <div
                                        {...droppableProps}
                                        ref={innerRef}
                                        className={`${styles.frame_promo_container}`}
                                    >
                                        <Draggable
                                            disableInteractiveElementBlocking={true}
                                            draggableId={`${props.frame.fpsRecId?.toString()}`}
                                            isDragDisabled={isDisableDraggable}
                                            index={props.index}
                                        >
                                            {(
                                                {innerRef, draggableProps, dragHandleProps},
                                                snapshot
                                            ) => (
                                                <div
                                                    className={`${styles.frame_promo} ${styles.frame_promo_without_content}`}
                                                    ref={innerRef}
                                                    {...dragHandleProps}
                                                    {...draggableProps}
                                                    style={getStyle(draggableProps.style, snapshot)}
                                                >
                                                    <Box sx={{
                                                        display: `flex`,
                                                        height: `fit-content`,
                                                        width: `100%`,
                                                        justifyContent: `space-between`
                                                    }}>
                                                        <Box>Frame {props.frame.fpsCode}</Box>
                                                        {
                                                            promotionsItemsState.isQualified &&

                                                            <Button
                                                                sx={{
                                                                    display: `flex`,
                                                                    cursor: `${props.frame.qualificationLevel !== 0 ? `pointer` : `initial`}`
                                                                }}
                                                                onClick={setQualificationForFrame}
                                                                disabled={props.frame.qualificationLevel === 0 || isUserViewer || isUserEditor}
                                                            >
                                                                {
                                                                    props.frame.qualificationLevel === 0 &&
                                                                    <NotApproveFrame
                                                                        title={`Frame Unqualified/Empty.`}/>
                                                                }
                                                                {
                                                                    props.frame.qualificationLevel === 1 &&
                                                                    <ApproveFrameForSystem
                                                                        title={`Frame Qualified by System.`}/>
                                                                }
                                                                {
                                                                    props.frame.qualificationLevel === 2 &&
                                                                    <ApproveFrame title={`Frame Qualified.`}/>
                                                                }
                                                            </Button>
                                                        }
                                                        {isHover && !isNotPromoFrameType && (
                                                            <div
                                                                className={styles.right_corner_menu_for_target}
                                                            >
                                                                <Button
                                                                    disableRipple={true}
                                                                    ref={anchorRefForFrameMenu}
                                                                    aria-controls={
                                                                        isOpenedFrameMenu
                                                                            ? "menu-list-grow"
                                                                            : undefined
                                                                    }
                                                                    aria-haspopup="true"
                                                                    onClick={handleToggleForFrame}
                                                                >
                                                                    <MenuOnHover/>
                                                                </Button>
                                                                <MenuForPromotion
                                                                    list={clickMenuDataForFrame}
                                                                    createNewPromotion={createNewPromotion}
                                                                    infoForMenu={`menuForEmptyFrame`}
                                                                />
                                                            </div>
                                                        )}
                                                    </Box>
                                                    {
                                                        isNotPromoFrameType &&
                                                        <Box sx={{
                                                            flex: `1 1 auto`,
                                                            height: `0`,
                                                            display: `flex`,
                                                            alignItems: `center`,
                                                            flexFlow: "row",
                                                            columnGap: "8px"
                                                        }}>
                                                            <Box sx={{width: "32px", height: "32px",
                                                                "& > svg > rect": {
                                                                    fill: (flyerIconStyleType === 2 || flyerIconStyleType === 3) ? mainGuiColorForFlyer : undefined
                                                                }
                                                            }}>
                                                                {frameIcon}
                                                            </Box>
                                                            <Typography fontSize={`14px`} fontWeight={500}>
                                                                {frameTypeTitle}
                                                            </Typography>
                                                        </Box>
                                                    }
                                                </div>
                                            )}
                                        </Draggable>
                                        {placeholder}
                                    </div>
                                )}
                            </Droppable>
                        )}
                    </div>
                </div>
                {isOpenPromotionModalPopup && (
                    <PromotionDetailsModalPopup
                        isShow={isOpenPromotionModalPopup}
                        isNewPromotion={isNewPromotion}
                        promotionData={isNewPromotion ? {} : props.promo}
                        openPromotionModalPopup={openPromotionModalPopup}
                        isHebrew={props.isHebrew}
                        currencySymbol={props.currencySymbol}
                        frameData={props.frame}
                        isUnlinked={false}
                    />
                )}

                {isOpenItemModal && (
                    <CreateEditItemModal
                        isShow={isOpenItemModal}
                        defaultContentForModal={selectedItem}
                        isNewItem={isNewItem}
                        setOpenItemModal={setOpenItemModal}
                        promo={props.promo ? props.promo : {}}
                        lang={flyerDetailsState?.flyLacRec?.lacCode!}
                        imageSrc={imageSrc}
                    />
                )}
            </>
        );
    },
    (prevProps, nextProps) => {
        if (
            prevProps.frame === nextProps.frame ||
            prevProps.promo === nextProps.promo ||
            prevProps.index === nextProps.index ||
            prevProps.isHebrew === nextProps.isHebrew ||
            prevProps.frames === nextProps.frames ||
            prevProps.currencySymbol === nextProps.currencySymbol
        ) {
            return false;
        }
        return true;
    }
);

